<dcp-contact-us-button
  [isButton]="false"
  [errorMessage]="errorMessage"
  [buttonText]="innerText"
  class="d-inline me-025"></dcp-contact-us-button>
<span *ngIf="isEnd">{{ 'common.dot' | cxTranslate }}</span>
